import { useSelector } from 'react-redux'
import appConfigs from 'app/configs/appConfigs'
import * as R from 'ramda'

export const useSubscription = () => {
  return useSelector(R.path(['place', 'activeSubscription']))
}

export const usePlan = () => {
  return useSelector(R.path(['place', 'activeSubscription', 'plan']))
}

export const hasPlanCanceled = R.prop('endsAt')
export const getIsOverLimitOverdraft = ({
  sendingSubscriberNumber,
  planNotesQuantityPerMonth,
  notesAvailable,
}) => {
  if (notesAvailable < 0) {
    return false
  }

  return (
    sendingSubscriberNumber >
    notesAvailable +
      (planNotesQuantityPerMonth * appConfigs.limitOverdraftPercent) / 100
  )
}

export const useNotesAvailable = () => {
  return useSelector(
    R.pathOr(0, ['place', 'activeSubscription', 'info', 'notesAvailable']),
  )
}

export const useOverdraftCount = () => {
  return useSelector(
    R.pathOr(0, ['place', 'activeSubscription', 'overdraftCount']),
  )
}

export const hasOverdraftByNotesAvailable = R.lt(R.__, 0)
export const hasOverdraftByOverdraftCount = R.gt(R.__, 0)
